<template>
	<div :class="'modal_wrap ' + addClass">
		<div class="overlay"></div>
		<div class="modal_card">
			<span class="modal_close" @click="$emit('closeModal')"></span>
			<slot />
		</div>
	</div>
</template>

<script>
export default {
	name: 'ModalView',
	props: {
		addClass: {
			type: String,
			default: '',
		},
	},
	mounted() {
		document.body.classList.add('overflow_h');
	},
	beforeUnmount() {
		document.body.classList.remove('overflow_h');
	},
};
</script>
